/*
 * Copyright 2025 Intuition Robotics ltd
 */
import type {ApiWithBody} from "@intuitionrobotics/thunderstorm";
import type {PartialProperties} from "@intuitionrobotics/ts-common";
import type {MessageType} from "@intuitionrobotics/push-pub-sub";
import type {ApiWithQuery} from "@intuitionrobotics/thunderstorm/shared/types";

export enum TabPermissions {
    CLINICAL = "CLINICAL",
    MESSAGES = "MESSAGES",
    CLINICAL_MESSAGES = "CLINICAL_MESSAGES"
}

export type PermissionLevel = { [orgId: string]: OrgRoleLevel[] | undefined };
export type DB_Permission = {
    id: string;
    name: string;
    orgRoles: PermissionLevel
    appRoles: AppRoleLevel[]
}

export enum OrgRoleLevel {
    CS_MESSAGE = "CS_MSG",
    CL_MESSAGE = "CL_MSG",
    EX_MESSAGE = "EX_MSG",
    USER_DATA = "USER_DATA",
    REMINDERS = "REMINDERS",
    // TODO: add viewer roles
    //    USER_DATA_VIEW = "USER_DATA_VIEW"
}

export const ID_ALL = "ALL";

export enum AppRoleLevel {
    SuperAdmin = "SUPER_ADMIN",
    AdminView = "ADMIN_VIEW",
    Demo = "DEMO",
    Commands = "COMMANDS",
    ExternalCommands = "EC",
}

export const adminRoles = [AppRoleLevel.AdminView, AppRoleLevel.SuperAdmin];
export const messagingRoles = [OrgRoleLevel.CS_MESSAGE, OrgRoleLevel.CL_MESSAGE, OrgRoleLevel.EX_MESSAGE];

export type Request_SetPermissions = {
    permission: PartialProperties<DB_Permission, "id">
    userIds: string[]
}

export type PermissionsApi_Set = ApiWithBody<"/v1/permissions/set", Request_SetPermissions, string>;

export type Api_PermissionList = ApiWithQuery<"/v1/permissions/list", DB_Permission[]>;
export const PushKey_PermissionUpdate = "permission-update";
export type MessageType_PermissionUpdate = MessageType<typeof PushKey_PermissionUpdate, { userId: string }, {}>
